export function MediaFrame({ children, className = '', ...props }) {
  return (
    <div {...props} className={`media-frame ${className}`.trim()}>
      {children}
    </div>
  );
}
